import { createStore } from 'vuex'
import axios from "axios";

export default createStore({
  state: {
    menuType: 'desktop',
    sidebarHidden: true,

    token: '',
    role: ''
  },
  getters: {
    getMenuType (state) {
      return state.menuType
    },
    getSidebarHidden (state) {
      return state.sidebarHidden
    },
    getToken(state){
      return state.token
    },
    getRole(state){
      return state.role
    }
  },
  mutations: {
    changeSidebarHidden (state, payload) {
      state.sidebarHidden = payload
    },
    changeMenuType (state, payload) {
      state.menuType = payload
    },
    changeToken(state, payload){
      state.token = payload
      localStorage.setItem('token', payload)
      if(payload){
        axios.defaults.headers.Authorization = `Bearer ${payload}`
      }else{
        axios.defaults.headers.Authorization = ``
      }
    },
    changeRole(state, payload){
      state.role = payload
      localStorage.setItem('role', payload)
    }
  },
  actions: {
    login(context, signin = {}){
      context.commit('changeToken', signin.token)
      context.commit('changeRole', signin.role)
    },
    logout(context){
      context.commit('changeToken', '')
      context.commit('changeRole', '')
    },
    async loadRole(context){
      return axios.get('/api/role/get')
    }
  },
  modules: {
  }
})
